import React from 'react';
import CoachStep from './CoachStep';
import UserActions from 'actions/UserActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import UserStore from 'stores/UserStore';
import Loading from 'components/pure/utils/Loading';

class CoachStepContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {coachesLoaded: false};
  }

  static getStores() {
    return [AuthStore, UserStore];
  }

  static getPropsFromStores() {
    return {
      sessionUser: AuthStore.getState().user,
      ...UserStore.getState().toObject(),
    };
  }

  async componentDidMount() {
    const {editMode, sessionUser, onChange, model: coachingPlan} = this.props;

    this.setState({coachesLoaded: false});

    const coaches = await UserActions.fetchManagersAndCoaches();
    const admins = await UserActions.fetchAll({roles: ['admin']});
    const found =
      coaches.find(m => m.userId === sessionUser.id) ||
      admins.find(m => m.userId === sessionUser.id);

    if (!editMode && found) {
      onChange(coachingPlan.setIn(['coach', 'id'], found.userId).setIn(['coach', 'info'], found));
    }

    this.setState({coachesLoaded: true});
  }

  render() {
    const {coachesLoaded} = this.state;

    if (!coachesLoaded) {
      return (
        <div className="coaching-step">
          <Loading />
        </div>
      );
    }

    return <CoachStep {...this.props} />;
  }
}

const connectedComponent = connectToStores(CoachStepContainer);
connectedComponent.title = CoachStep.title;
connectedComponent.validate = CoachStep.validate;
export default connectedComponent;
